import React, { useEffect, useState } from "react";
import HeroFrame from "./HeroFrame";

const HeroSceneMedia = ({
  activeHeroUrl,
  activeHeroVideo,
  heroAnim,
  heroVideoRef,
  heroVisible,
  isMobile,
  isPodcastPlaying,
  onAnimationEnd
}) => {
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    setVideoReady(false);
  }, [activeHeroVideo?.key, activeHeroVideo?.url]);

  if (!heroVisible) return null;

  return (
    <div
      className={`heroFrameWrap ${heroAnim}`}
      onAnimationEnd={onAnimationEnd}
      style={{
        position: "absolute",
        zIndex: 6,
        top: isPodcastPlaying ? 76 : 80,
        bottom: 112,
        left: 0,
        right: 0,
        display: "grid",
        placeItems: "center",
        pointerEvents: "none"
      }}
    >
      <div
        style={{
          width: isMobile ? "min(82vh, 90vw, 880px)" : "min(68vh, 68vw, 820px)",
          maxWidth: "92vw"
        }}
      >
        {activeHeroVideo?.url ? (
          <HeroFrame>
            {activeHeroUrl ? (
              <img
                src={activeHeroUrl}
                alt="scene illustration"
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
              />
            ) : null}
            <video
              key={activeHeroVideo.key}
              ref={heroVideoRef}
              src={activeHeroVideo.url}
              muted
              playsInline
              loop={activeHeroVideo.loop}
              preload="metadata"
              onLoadedData={() => setVideoReady(true)}
              onCanPlay={() => setVideoReady(true)}
              onError={() => setVideoReady(false)}
              onStalled={() => setVideoReady(false)}
              style={{
                position: "absolute",
                inset: 0,
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                opacity: videoReady ? 1 : 0,
                transition: "opacity 250ms ease"
              }}
            />
          </HeroFrame>
        ) : (
          <HeroFrame src={activeHeroUrl || ""} alt="scene illustration" />
        )}
      </div>
    </div>
  );
};

export default HeroSceneMedia;
